import { getIpcRenderer } from '../reducers/ipc-loader.js';

const dataListeners = new Set();
const errorListeners = new Set();
let initialized = false;

async function init() {   
    if (initialized) return;
    initialized = true;
    const ipcRenderer = await getIpcRenderer();    
    if (!ipcRenderer) return;

    ipcRenderer.on('serial-data', (_event, payload) => {         
        dataListeners.forEach((fn) => fn(payload));
    });
    ipcRenderer.on('serial-error', (_event, payload) => {
        errorListeners.forEach((fn) => fn(payload));
    });
}

/** Подписаться на данные. Возвращает функцию отписки. */
export function onSerialData(fn) {      
    init();
    dataListeners.add(fn);
    return () => {dataListeners.delete(fn);}
}

export function onSerialError(fn) {
    init();
    errorListeners.add(fn);
    return () => errorListeners.delete(fn);
}